@if (isLoading()) {
  <lib-overlay-loader />
} @else {
  <div
    data-test="group-details-page"
    [class]="floatingPageClasses()"
    [class.flex]="floating()"
    [class.flex-col]="floating()"
    [class.gap-lg]="floating()">
    <!-- Floating: header, group info and assigned users share one card -->
    <div
      data-test="group-details-card"
      [class.floating-card]="floating()"
      [class.p-2xl]="floating()">
      <header
        [class.border-b]="!floating()"
        [class.border-neutral-300]="!floating()"
        [class.py-lg]="!floating()">
        <ng-template #backButton>
          <a data-test="group-details-back" (click)="goBack()" class="bg-white">
            <lib-chevron-down-icon
              [iconClass]="'size-10 text-neutral-900 rotate-90 p-sm rounded-lg cursor-pointer border border-neutral-200'" />
          </a>
        </ng-template>

        @if (!floating()) {
          <div class="flex justify-between items-center mb-2xl">
            <ng-container [ngTemplateOutlet]="backButton" />
          </div>
        }

        <div class="flex justify-between items-center">
          <div class="flex gap-lg items-center">
            @if (floating()) {
              <ng-container [ngTemplateOutlet]="backButton" />
            }
            @if (groupDetails().image && groupDetails().image?.url) {
              <img
                [src]="groupDetails().image?.url ?? ''"
                [alt]="groupDetails().image?.name ?? ''"
                class="rounded-full size-16" />
            } @else {
              <div
                class="avatar flex items-center justify-center rounded-full bg-primary-50">
                <span class="text-2xl rtl:text-xl font-medium text-primary-500">
                  {{ groupDetails().name | avatar }}
                </span>
              </div>
            }

            <div class="flex flex-col gap-md">
              <div class="flex items-center gap-sm">
                <h2 class="font-semibold text-2xl">
                  {{ groupDetails().name }}
                </h2>
              </div>

              <p class="text-sm font-medium text-neutral-500">
                #{{ groupDetails().id }}
              </p>
            </div>
          </div>

          <a
            [routerLink]="[
              `${ADMIN_ROUTES.GROUPS.FORM}` | tenantPath: 'admin',
              groupId(),
            ]"
            id="group_details_screen_edit_button"
            class="bg-white text-primary-600 font-medium text-base py-sm px-2xl border-none rounded-md gap-sm flex">
            <lib-edit-icon [iconClass]="'size-5 text-primary-600'" />

            {{ 'group_details_screen_edit_button' | transloco }}
          </a>
        </div>
      </header>

      <div class="mt-2xl">
        <div class="view-mode-section-title py-lg mb-2xl">
          <h6 class="">
            {{ 'group_details_screen_group_info_section_title' | transloco }}
          </h6>
        </div>

        <div
          class="grid [grid-template-columns:repeat(auto-fill,minmax(20rem,1fr))] gap-lg"
          [class.mb-2xl]="!floating()">
          <div>
            <p class="view-mode-label">
              {{ 'group_details_screen_group_name_label' | transloco }}
            </p>

            <p class="view-mode-value break-word text-neutral-900">
              {{ groupDetails().name }}
            </p>
          </div>
        </div>
      </div>

      <div data-test="group-details-users-section" class="mt-5xl">
        <div
          class="flex items-center justify-between border-b border-neutral-200 pb-lg">
          <div class="flex items-center gap-lg">
            <h6 class="text-neutral-900 font-semibold text-lg px-lg">
              {{
                'group_details_screen_assigned_users_section_title' | transloco
              }}
            </h6>

            <span class="bg-primary-50 rounded-2xl">
              <p class="text-primary-700 px-md py-x-sm font-medium">
                {{ cardListTotalItems() }}
              </p>
            </span>
          </div>

          <div>
            <div class="search-input relative flex gap-md items-center">
              <label
                class="flex items-center w-full border border-neutral-300 rounded-md text-sm p-md">
                <input
                  type="text"
                  [id]="'search'"
                  [placeholder]="'search_by_name_placeholder' | transloco"
                  [style.cursor]="
                    !assignedList().length && !searchTerm() ? 'not-allowed' : ''
                  "
                  [disabled]="!assignedList().length && !searchTerm()"
                  class="bg-transparent text-base w-full pe-2xl placeholder:text-sm placeholder:text-neutral-500"
                  [ngModel]="searchTerm()"
                  (ngModelChange)="onSearchTermChange($event)" />

                <div
                  class="icon absolute end-3 inset-y-3 cursor-pointer flex items-center">
                  <lib-search-icon [iconClass]="'size-5 text-neutral-500'" />
                </div>
              </label>
            </div>
          </div>
        </div>

        <div class="my-lg">
          @if (isCardListLoading()) {
            <div class="flex justify-center items-center h-full my-4xl">
              <lib-loader />
            </div>
          } @else {
            <lib-group-user-card
              [list]="assignedList()"
              [itemType]="'User'"
              [mode]="'view'" />
          }
        </div>

        @if (assignedList().length) {
          <div class="mt-2xl">
            <lib-paginator
              [sizeOptionsLabel]="
                'pagination_number_of_rows_per_page_label' | transloco
              "
              [nextBtnLabel]="'pagination_next_button_label' | transloco"
              [previousBtnLabel]="
                'pagination_previous_button_label' | transloco
              "
              [currentPage]="cardListCurrentPage()"
              [totalPages]="cardListTotalPages()"
              [totalItems]="cardListTotalItems()"
              [currentSize]="15"
              (goTo)="handleCardListPagination($event)"
              (next)="handleCardListPagination($event)"
              (previous)="handleCardListPagination($event)" />
          </div>
        }
      </div>
    </div>
  </div>
}
